import React, { useEffect, useState } from "react"
import { useNavigate, Link } from "react-router-dom";
import WOW from "wowjs";
import "animate.css";
import Map from '../images/graph-image.png'
import { REGISTRATION_ABI, REGISTRATION_ADDRESS, MATRIX_CONTRACT, MATRIX_ABI } from '../constants/contract'
import useWalletConnect from "../hooks/useWalletConnect";
import { Contract, isAddress } from "ethers";
import contractErrorHandler from "../hooks/contractErrorHandler";
import { useUser } from "../context/UserContext";
import waves from '../images/waves.png'
import InnerHeader from '../components/InnerHeader'
import logo from '../images/logo.png'
import Slot from '../components/Slot'
const Slots = () => {

    const navigate = useNavigate();
    const { setUser, userData } = useUser();


    if (!userData) navigate('/register')

    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    function trimAddress(address, length = 4) {
        if (!address) return '';
        return `${address.slice(0, 2 + length)}...${address.slice(-length)}`;
    }

    useEffect(() => {
        new WOW.WOW().init();
    }, []);

    const { parseError } = contractErrorHandler();




    const {
        account,
        connectBrowserWallet,
        connectWalletConnect,
        disconnectWallet,
        connectionType,
        loading,
        signer
    } = useWalletConnect();


    const copyText = () => {
        navigator.clipboard.writeText("https://markman.pro/register?ref=" + account.address);
        alert('Copied Referral Link Successfully')
    };

    const [isLoading, setIsLoading] = useState(false);
    const [tickets, setTickets] = useState({})
    useEffect(() => {
        setIsLoading(true);
        async function loadData() {
            try {
                if (!signer) return;

                const contract = new Contract(MATRIX_CONTRACT, MATRIX_ABI, signer);


                const ticks = await contract.getUserTickets(account?.address)

                setTickets(ticks);



            } catch (err) {
                setError(parseError(err))
                console.log(err)
            } finally {
                setIsLoading(false);
            }
        }

        loadData()
    }, [signer])

    return (
        <>
            <InnerHeader />

            <section className="bg-secondary-100" >

                <div className="h-fit py-10  px-4 md:px-6">

                    <div className="pt-20" >

                        <div className="grid grid-cols-12" >

                            <div className="col-span-12 md:col-span-1"></div>


                            <div className="col-span-12 md:col-span-10">

                                <div className="grid grid-cols-12" >

                                    <div className="col-span-12 md:col-span-6 lg:col-span-6 text-white  px-2 wow animate__animated animate__fadeInUp mb-5" data--wow-delay="0.5s">
                                        <div className="bg-secondary-200  py-5 rounded-b-3xl border-t border-secondary shadow-2xl">
                                            <div className="flex-col">


                                                <div className='text-center flex justify-center'>

                                                    <img src={logo} className="w-[100px]" />
                                                </div>

                                                <h3 className="my-3 text-md font-pmedium text-center text-secondary">

                                                    MY TICKETS <i className="fa fa-tag"></i>

                                                </h3>
                                                <div className="px-3 pb-4 text-center">
                                                {isLoading ? (
                                                    <>
                                                        <div className="text-center"><i className="fa fa-spin fa-spinner"></i>
                                                        </div>
                                                    </>
                                                ) :
                                                    (
                                                        <>
                                                            {tickets.length > 0 ? tickets.map((item, index) => (
                                                               <> <div key={index} className="text-center font-psemibold px-2 py-1 text-xs font-pmedium bg-secondary text-black rounded mr-1 inline-block">
                                                                    <i className="fa fa-tag"></i> {tickets[index]}
                                                                </div>

                                                                </>

                                                            ))
                                                                : (<>
                                                                    <div className="text-center bg-red-100 border border-red-400 text-red-700 rounded text-xs"><i className="fa fa-tear"></i> You do not have any ticket yet</div></>)}

                                                        </>)}

                                                <p className="text-xs text-center font-pregular text-[10px] mx-5 rounded-xl border-t border-secondary pt-3 mt-4">These are your tickets for this week</p>
                                            </div>

                                            </div>

                                        </div>
                                    </div>



                                    <div className="col-span-12 md:col-span-6 lg:col-span-6 text-white  px-2 wow animate__animated animate__fadeInUp mb-5" data--wow-delay="0.5s">
                                        <div className="bg-secondary-200  p-10 py-5 rounded-b-3xl border-t border-secondary shadow-2xl">
                                            <div className="flex-col">


                                                <div className='text-center flex justify-center'>

                                                    <img src={logo} className="w-[100px]" />
                                                </div>

                                                <h3 className="my-3 text-md font-pmedium text-center text-secondary">

                                                    TOTAL LOTTERY WON <i className="fa fa-tag"></i>

                                                </h3>

                                                <h3 className="text-xl text-gray text-center font-psemibold">
                                                    $0
                                                </h3>

                                                <p className="text-xs text-center font-pregular text-[10px] rounded-xl border-t border-secondary pt-3 mt-4">This is how much you have won total from lottery</p>
                                            </div>

                                        </div>
                                    </div>




                                    <div className="col-span-12 md:col-span-6 lg:col-span-6 text-white  px-2 wow animate__animated animate__fadeInUp mb-5" data--wow-delay="0.5s">
                                        <div className="bg-secondary-200  p-10 py-5 rounded-b-3xl border-t border-secondary shadow-2xl">
                                            <div className="flex-col">


                                                <div className='text-center flex justify-center'>

                                                    <img src={logo} className="w-[100px]" />
                                                </div>

                                                <h3 className="my-3 text-md font-pmedium text-center text-secondary">

                                                    CLAIM LOTTERY <i className="fa fa-tag"></i>

                                                </h3>

                                                <h3 className="text-xl text-gray text-center font-psemibold">
                                                    $0
                                                </h3>

                                                <p className="text-xs text-center font-pregular text-[10px] rounded-xl border-t border-secondary pt-3 mt-4">This is your pending lottery prize not yet claimed</p>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>


                        </div>
                    </div>

                </div>
            </section>


        </>

    )
}

export default Slots;